import script from "./LogoTitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./LogoTitle.vue?vue&type=script&setup=true&lang=ts"

import "./LogoTitle.vue?vue&type=style&index=0&id=27934078&scoped=true&lang=scss"

import exportComponent from "/var/www/fgc-dev-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27934078"]])

export default __exports__